// Module
var code = "<div class=\"modal-header\"> <button type=\"button\" class=\"close\" data-ng-click=\"$dismiss()\" aria-label=\"{{closeLabel}}\">&times;</button> <h4 class=\"modal-title\" data-i18n=\"t18n store info\"></h4> </div> <div class=\"modal-body\"> <ui-v2-embed src=\"{{storeInfoSrc}}\" class=\"store-info-embed\"></ui-v2-embed> </div> ";
// Exports
export default code;